import Schedule from "view/schedule";

export const projectKpis = (scheduleApiData, costApiData) => {
    const kpis = [];


    if (scheduleApiData) {
        kpis.push(
            {
                key: "project-progress",
                label: "Project Progress",
                type: "progress",
                planDisplayText: "Planned",
                actualDisplayText: "Actual",
                plan: scheduleApiData?.planProgress || 0,
                actual: scheduleApiData?.actualProgress || 0,
                bg: getBGColor(scheduleApiData?.planProgress, scheduleApiData?.actualProgress),//"#FEC7C7",
                iconBg: getIconBGColor(Schedule?.planProgress, scheduleApiData?.actualProgress),// "#FA5A7D",
                unit: "%"
            },
            {
                key: "project-start-date",
                label: "Project Start Date",
                value: scheduleApiData?.projectStartDate,
                type: "date",
                bg: "#FFF4DE",
                iconBg: "#FF947A"
            },
            {
                key: "project-end-date",
                label: "Project End Date",
                value: scheduleApiData?.projectEndDate,
                type: "date",
                bg: "#FFF4DE",
                iconBg: "#FF947A"
            },
            {
                key: "anticipate-end-date",
                label: "Anticipated End Date",
                value: scheduleApiData?.projectProjectedEndDate,
                type: "date",
                // bg: "#FEC7C7",
                // iconBg: "#FA5A7D",
                bg: getBGColor(scheduleApiData?.projectProjectedEndDate, scheduleApiData?.projectEndDate),//"#FEC7C7",
                iconBg: getIconBGColor(scheduleApiData?.projectProjectedEndDate, scheduleApiData?.projectEndDate),// "#FA5A7D",
            }
        );
    }
    // if (costApiData) {
    //     kpis.push(
    //         {
    //             key: "project-value",
    //             label: "Baseline Project Value",
    //             value: costApiData?.baselinecost,
    //             type: "cost",
    //             bg: "#FFF4DE",
    //             iconBg: "#FF947A",
    //             subTexts: [
    //                 { label: "Hard Cost", value: costApiData?.baselinehardcost },
    //                 { label: "Soft Cost", value: costApiData?.baselinecosftcost },
    //             ],
    //             unit: "Cr."
    //         },
    //         {
    //             key: "project-value",
    //             label: "Revised Project Value",
    //             value: costApiData?.revisedbaselinecost,
    //             type: "cost",
    //             bg: getBGColor(costApiData?.revisedbaselinecost, costApiData?.baselinecost),// "#FFF4DE",
    //             iconBg: getIconBGColor(costApiData?.revisedbaselinecost, costApiData?.baselinecost),// "#FF947A",
    //             subTexts: [
    //                 { label: "Hard Cost", value: costApiData?.revisedbaselinehardcost },
    //                 { label: "Soft Cost", value: costApiData?.revisedbaselinecosftcost },
    //             ],
    //             unit: "Cr."
    //         },
    //         {
    //             key: "project-earned-value",
    //             label: "Project Earned Value",
    //             plan: costApiData?.actual || 0,
    //             actual: costApiData?.earned || 0,
    //             type: "progress",
    //             planDisplayText: "Actual",
    //             actualDisplayText: "Earned",
    //             bg: getBGColor(costApiData?.actual, costApiData?.earned),// "#FEC7C7",
    //             iconBg: getIconBGColor(costApiData?.actual, costApiData?.earned),// "#FA5A7D",
    //             unit: "Cr."
    //         }
    //     );
    // }

    return kpis;
};


// export const costKpiData = (costKpi) => {

//     return [
//         {
//             label: "Baseline Cost",
//             value: costKpi?.revisedbaselinecost,
//             key: "baseline-cost",
//             color: "#0088FF"
//         },
//         {
//             label: "Estimate at Completion  (EAC)",
//             value: costKpi?.eac,
//             key: "estimate-at-completion",
//             color: getIconBGColor(costKpi?.eac, costKpi?.revisedbaselinecost)// "#1A932E"
//         },
//         // {
//         //     label: "Estimate to Completion  (ETC)",
//         //     value: "233.92 Cr",
//         //     key: "estimate-to-completion",
//         //     color: "#FF8D28"
//         // },
//     ]
// }

const getBGColor = (planned, actual) => {
    if ((actual == null && planned == null) || (actual == 0 && planned == 0))
        return "#FFF4DE";
    else if (actual >= planned) {
        return "#DCFCE7"
    }
    else {
        return "#FEC7C7"
    }

}
const getIconBGColor = (planned, actual) => {
    if ((actual == null && planned == null) || (actual == 0 && planned == 0))
        return "#FF947A";
    else if (actual >= planned) {
        return "#3CD856"
    }
    else {
        return "#FA5A7D"
    }
}

export const engineeringKpiMapper = (raw) => {
    if (!raw) return []

    return [
        {
            label: "Total Drawings Planned",
            value: String(raw.totalDrawingsSubmitted || 0), //677
            bg: "#E7E7EB",
            iconBg: "#7C7C80",
        },
        {
            label: "Drawings Received",
            value: String(raw.drawingsReceived || 0), //677
            bg: "#F3E8FF",
            iconBg: "#BF83FF",
        },
        {
            label: "Drawings Balance",
            value: String(raw.drawingsBalance || 0), //677
            bg: "#FFE2E5",
            iconBg: "#FA5A7D",
        },
        // {
        //     label: "Total Drawings Planned",
        //     value: String(raw.totalDrawingsSubmitted || 0), //677
        //     bg: "#E7E7EB",
        //     iconBg: "#7C7C80",
        // },
        // {
        //     label: "Total Drawing Approved",
        //     value: String(raw.totalDrawingsApproved || 0),//190
        //     bg: "#DCFCE7",
        //     iconBg: "#3CD856",
        // },
        // {
        //     label: "Drawing Under Review",
        //     value: String(raw.drawingUnderReview || 0),
        //     bg: "#F3E8FF",
        //     iconBg: "#BF83FF",
        // },
        // {
        //     label: "Drawing Delayed",
        //     value: String(raw.drawingDelayed || 0),
        //     bg: "#FFE2E5",
        //     iconBg: "#FA5A7D",
        // },
    ];
}

export const procurementKpiMapper = (raw) => {
    if (!raw) return []

    return [
        {
            label: "Total Packages",
            value: String(raw?.servicesPackages || 0), //677
            bg: "#E7E7EB",
            iconBg: "#7C7C80",
        },
        {
            label: "Awarded",
            value: String(raw?.totalNoAwarded || 0),//190
            bg: "#DCFCE7",
            iconBg: "#3CD856",
        },
        {
            label: "In-progress",
            value: String(raw?.totalNoOfInProgress || 0),
            bg: "#F3E8FF",
            iconBg: "#BF83FF",
        },
        {
            label: "Not Started",
            value: String(raw.totalNoOfNotStarted || 0),
            bg: "#FFF4DE",
            iconBg: "#FF947A",
        },
    ];
}